import { useState, lazy, Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AnnouncementBanner from "@/components/AnnouncementBanner";

// Lazy-loaded non-critical widgets & modals
const ChatbotWidget = lazy(() => import("@/components/ChatbotWidget"));
const BookingDialog = lazy(() => import("@/components/BookingDialog"));
const Toaster = lazy(() => import("sonner").then((mod) => ({ default: mod.Toaster })));

export default function Layout() {
  const [bookOpen, setBookOpen] = useState(false);
  const [bookingLoaded, setBookingLoaded] = useState(false);
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");
  const openBooking = () => {
    setBookingLoaded(true);
    setBookOpen(true);
  };

  // Admin pages render full-bleed without site chrome.
  if (isAdmin) {
    return (
      <div className="min-h-screen bg-background text-foreground">
        <Suspense fallback={<div className="h-[50vh] grid place-items-center"><div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" /></div>}>
          <Outlet />
        </Suspense>
        <Suspense fallback={null}>
          <Toaster theme="dark" position="bottom-right" />
        </Suspense>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background text-foreground grain">
      <Navbar onBookCall={openBooking} />
      <main data-testid="app-main">
        <Suspense fallback={<div className="h-[50vh] grid place-items-center"><div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" /></div>}>
          <Outlet context={{ openBooking }} />
        </Suspense>
      </main>
      <Footer />
      <Suspense fallback={null}>
        <ChatbotWidget onBookCall={openBooking} />
        {bookingLoaded && (
          <BookingDialog open={bookOpen} onOpenChange={setBookOpen} />
        )}
        <Toaster theme="dark" position="bottom-right" />
      </Suspense>
    </div>
  );
}
